import { render, staticRenderFns } from "./GiVendorIndex.vue?vue&type=template&id=97396d18&"
import script from "./GiVendorIndex.vue?vue&type=script&lang=js&"
export * from "./GiVendorIndex.vue?vue&type=script&lang=js&"
import style0 from "./GiVendorIndex.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports